"use strict";

(function () {
  'use strict';

  function optionsModalCtrl($http, $filter, TripService, Moment) {
    var vm = this;

    vm.selectOption = function (option) {
      var firstChar;

      if (option.hasOwnProperty('specialID')) {
        option.optionsTypeID = 'P' + option.specialID;
      }

      if (option.hasOwnProperty('optionsTypeID')) {
        firstChar = option.optionsTypeID.charAt(0);
      }

      var _type = {
        D: 'defaultOptions',
        C: 'customOptions',
        P: 'specials'
      };

      if (firstChar && vm.transaction.hasOwnProperty(_type[firstChar])) {
        //console.log(vm.transaction[_type[firstChar]]);
        vm.transaction[_type[firstChar]].forEach(function (tOption) {
          //console.log(option.optionsTypeID);
          //console.log(tOption.optionsTypeID);
          if (option.optionsTypeID === tOption.optionsTypeID) {
            tOption.quantity = option.quantity;
            tOption.quantityDays = option.quantityDays;
          }
        });
      }

      var newTrans = angular.copy(vm.transaction);

      _updateTransction(newTrans);
    };

    vm.save = function (transaction) {
      var addedOptions = vm.availableOptions.filter(function (option) {
        return option.quantity > 0;
      });
      vm.close({
        $event: {
          transaction: transaction,
          addedOptions: addedOptions
        }
      });
    };

    vm.cancel = function () {
      vm.dismiss({
        $event: 'cancel button'
      });
    };

    var _updateTransction = function _updateTransction(transaction) {
      vm.loading = true;
      TripService.calculateTrip(transaction).then(function (response) {
        vm.transaction = angular.copy(response);

        _updateAvailableOptions([].concat(vm.transaction.defaultOptions).concat(vm.transaction.customOptions).concat($filter('packageSpecials')(vm.transaction.specials)));

        vm.difference = vm.transaction.totalBalance - vm.currentTransaction.totalBalance;
        vm.loading = false;
      }, function (error) {
        console.log(error);
        vm.loading = false;
      });
    };

    function containsObject(obj, list) {
      var i;

      for (i = 0; i < list.length; i++) {
        if (list[i].optionsTypeID === obj.optionsTypeID) {
          return i;
        }
      }

      return -1;
    }

    function _updateAvailableOptions(optionsArr) {
      optionsArr.forEach(function (newOption) {
        var index = containsObject(newOption, vm.availableOptions);

        if (index >= 0) {
          vm.availableOptions[index].preTaxTotal = newOption.preTaxTotal;
          vm.availableOptions[index].quantity = newOption.quantity;
          vm.availableOptions[index].quantityDays = newOption.quantityDays;
          vm.availableOptions[index].priceDisplay = newOption.priceDisplay;
          vm.availableOptions[index].incurFeeDaily = newOption.incurFeeDaily;
          vm.availableOptions[index].maxQuantity = newOption.maxQuantity;

          if (vm.availableOptions[index].hasOwnProperty('specialID')) {
            vm.availableOptions[index].preTaxTotal = newOption.price;
          }
        }
      });
    } // ============ INIT ===============


    this.$onInit = function () {
      vm.loading = false;
      vm.currentTransaction = angular.copy(vm.transaction);
      vm.transaction = angular.copy(vm.transaction);
      vm.difference = vm.transaction.totalBalance - vm.currentTransaction.totalBalance; // create an initial list of available options

      vm.availableOptions = TripService.helpers.getAvailableOptions(vm.transaction); // set passed in option as selected if exists

      if (vm.option && vm.availableOptions.length) {
        vm.availableOptions.forEach(function (aOption) {
          if (vm.option === aOption.optionsTypeID) {
            aOption.quantity = 1;
            vm.selectOption(aOption);
          }
        });
      } // group all options by category


      vm.groupedOptions = TripService.helpers.groupOptionsByCategory(vm.availableOptions);
      var start = Moment(new Date(vm.transaction.startDate));
      var end = Moment(new Date(vm.transaction.endDate));
      vm.transactionDays = end.diff(start, 'days');
    };
  }

  optionsModalCtrl.$inject = ['$http', '$filter', 'TripService', 'Moment'];
  angular.module('options-modal', []).component('optionsModal', {
    bindings: {
      option: '<',
      transaction: '<',
      close: '&',
      dismiss: '&'
    },
    controller: optionsModalCtrl,
    templateUrl: 'components/options-modal/options-modal.html'
  });
})();